module.exports = window.wp.patterns;